<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="L0 开通商家（主体+账号）· L1 为已有商家开通模块（同一主体不加新号）。开通后将 B 端登录凭证告知商家。"
    />
    <div class="mb-12px flex flex-wrap gap-8px">
      <el-button
        v-hasPermi="['merchant:entity:create']"
        type="primary"
        @click="() => openCreateDialog()"
      >
        开通商家
      </el-button>
      <el-button @click="loadList">刷新</el-button>
      <!-- <el-button v-hasPermi="['merchant:entity:backfill']" @click="onBackfill">回填模块开通</el-button> -->
    </div>
    <el-table v-loading="loading" :data="list" border size="small">
      <el-table-column prop="id" label="主体 ID" width="90" />
      <el-table-column prop="name" label="名称" min-width="140" />
      <el-table-column prop="contactPhone" label="手机" width="120" />
      <el-table-column prop="loginUsername" label="登录账号" width="130" />
      <el-table-column label="已开模块" min-width="180">
        <template #default="{ row }">
          <template v-if="row.moduleIds?.length">
            <el-tag
              v-for="mid in row.moduleIds"
              :key="mid"
              class="mr-4px"
              size="small"
              type="success"
            >
              {{ moduleLabel(mid) }}
            </el-tag>
          </template>
          <span v-else class="text-[var(--el-text-color-secondary)]">未开通</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90" />
      <el-table-column label="操作" width="280" fixed="right">
        <template #default="{ row }">
          <el-button
            v-hasPermi="['merchant:module:open']"
            link
            type="primary"
            @click="openModuleDialog(row)"
          >
            开通模块
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty description="暂无商家主体，请点击「开通商家」" />
      </template>
    </el-table>

    <el-dialog v-model="createVisible" title="L0 · 开通商家" width="520px" destroy-on-close>
      <el-form :model="createForm" label-width="100px">
        <el-form-item label="主体名称" required>
          <el-input v-model="createForm.name" placeholder="公司/门店全称" />
        </el-form-item>
        <el-form-item label="联系手机" required>
          <el-input v-model="createForm.contactPhone" maxlength="11" placeholder="11 位手机号" />
        </el-form-item>
        <el-form-item label="登录账号" required>
          <el-input v-model="createForm.loginUsername" placeholder="默认可填手机号" />
        </el-form-item>
        <el-form-item label="登录密码" required>
          <el-input
            v-model="createForm.loginPassword"
            type="password"
            show-password
            maxlength="20"
            placeholder="6-20 位，开通后请发给商家"
          />
        </el-form-item>
        <el-form-item label="首批模块">
          <el-checkbox-group v-model="createForm.initialModuleIds">
            <el-checkbox
              v-for="option in initialModuleOptions"
              :key="option.moduleId"
              :value="option.moduleId"
            >
              {{ option.moduleName }}
            </el-checkbox>
          </el-checkbox-group>
          <div
            v-if="!initialModuleOptions.length"
            class="text-12px text-[var(--el-text-color-secondary)]"
          >
            暂无可用于平台首批开通的模块
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="createVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="onCreate">确定开通</el-button>
      </template>
    </el-dialog>

    <el-dialog
      v-model="moduleVisible"
      :title="`L1 · 开通${moduleLabel(openModuleId)}`"
      width="420px"
      destroy-on-close
    >
      <el-form label-width="90px">
        <el-form-item label="模块">
          <el-select v-model="openModuleId" style="width: 100%">
            <el-option
              v-for="option in appendModuleOptions"
              :key="option.moduleId"
              :label="option.moduleName"
              :value="option.moduleId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="moduleForm.name" />
        </el-form-item>
        <el-form-item v-if="openModuleId === 'O2O' || openModuleId === 'CAPACITY'" label="城市">
          <el-input v-model="moduleForm.city" placeholder="如 杭州" />
        </el-form-item>
        <template v-if="openModuleId === 'HOTEL'">
          <el-form-item label="业态">
            <el-select v-model="moduleForm.propertyType" style="width: 100%">
              <el-option label="酒店" :value="0" />
              <el-option label="民宿" :value="1" />
              <el-option label="客栈" :value="2" />
              <el-option label="公寓" :value="3" />
              <el-option label="青旅" :value="4" />
              <el-option label="度假村" :value="5" />
            </el-select>
          </el-form-item>
          <el-form-item label="经营模式">
            <el-select v-model="moduleForm.operationMode" style="width: 100%">
              <el-option label="自营" value="SELF_OPERATED" />
              <el-option label="平台托管" value="PLATFORM_MANAGED" />
              <el-option label="第三方入驻" value="THIRD_PARTY" />
            </el-select>
          </el-form-item>
          <el-form-item label="结算周期">
            <el-select v-model="moduleForm.settleCycle" style="width: 100%">
              <el-option label="实时结算" value="INSTANT" />
              <el-option label="日结" value="DAILY" />
              <el-option label="周结" value="WEEKLY" />
              <el-option label="月结" value="MONTHLY" />
            </el-select>
          </el-form-item>
          <el-form-item label="佣金率">
            <el-input-number
              v-model="moduleForm.commissionRate"
              :min="0"
              :max="100"
              :precision="2"
              style="width: 100%"
            />
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <el-button @click="moduleVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="onOpenModule">开通</el-button>
      </template>
    </el-dialog>

    <el-dialog
      v-model="credentialVisible"
      title="请将以下凭证发给商家"
      width="480px"
      :close-on-click-modal="false"
    >
      <el-descriptions :column="1" border>
        <el-descriptions-item label="主体名称">{{ credentialInfo.name }}</el-descriptions-item>
        <el-descriptions-item label="登录账号">{{
          credentialInfo.loginUsername
        }}</el-descriptions-item>
        <el-descriptions-item label="登录密码">{{
          credentialInfo.loginPassword
        }}</el-descriptions-item>
        <el-descriptions-item label="B 端入口">商家工作台（/store/login）</el-descriptions-item>
        <el-descriptions-item v-if="credentialInfo.modules.length" label="已开模块">
          {{ credentialInfo.modules.map(moduleLabel).join('、') }}
        </el-descriptions-item>
      </el-descriptions>
      <p class="mt-12px text-13px text-[var(--el-text-color-secondary)]">
        密码仅展示一次，请复制或截图后线下告知商家负责人。
      </p>
      <template #footer>
        <el-button @click="copyCredentials">复制凭证</el-button>
        <el-button type="primary" @click="credentialVisible = false">已告知商家</el-button>
      </template>
    </el-dialog>
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as EntityApi from '@/api/merchant/merchant-entity'
import { ContentWrap } from '@/components/ContentWrap'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'

defineOptions({ name: 'AdminMerchantEntity' })

const MODULE_LABEL: Record<string, string> = {
  MALL: '商城',
  O2O: '上门',
  CAPACITY: '运力',
  HOTEL: '酒店'
}

const route = useRoute()
const router = useRouter()
const list = ref<EntityApi.MerchantEntityItem[]>([])
const loading = ref(false)
const createVisible = ref(false)
const moduleVisible = ref(false)
const credentialVisible = ref(false)
const submitting = ref(false)
const openMerchantId = ref(0)
const openModuleId = ref('')
const initialModuleOptions = ref<EntityApi.MerchantModuleOption[]>([])
const appendModuleOptions = ref<EntityApi.MerchantModuleOption[]>([])
const createForm = reactive({
  name: '',
  contactPhone: '',
  loginUsername: '',
  loginPassword: '',
  initialModuleIds: [] as string[]
})
const moduleForm = reactive({
  name: '',
  city: '杭州',
  propertyType: 0,
  operationMode: 'THIRD_PARTY',
  settleCycle: 'MONTHLY',
  commissionRate: 0
})
const credentialInfo = reactive({
  name: '',
  loginUsername: '',
  loginPassword: '',
  modules: [] as string[]
})

const moduleLabel = (id: string) =>
  initialModuleOptions.value.find((x) => x.moduleId === id)?.moduleName ||
  appendModuleOptions.value.find((x) => x.moduleId === id)?.moduleName ||
  MODULE_LABEL[id] ||
  id
const resetCreateForm = () => {
  createForm.name = ''
  createForm.contactPhone = ''
  createForm.loginUsername = ''
  createForm.loginPassword = ''
  createForm.initialModuleIds = []
}

const openCreateDialog = (prefillModule?: string) => {
  resetCreateForm()
  if (prefillModule) {
    createForm.initialModuleIds = [prefillModule]
  }
  void loadInitialModuleOptions(prefillModule)
  createVisible.value = true
}

const loadInitialModuleOptions = async (prefillModule?: string) => {
  initialModuleOptions.value = await EntityApi.getMerchantModuleOptions('ADMIN_INITIAL')
  if (
    prefillModule &&
    !initialModuleOptions.value.some((option) => option.moduleId === prefillModule)
  ) {
    createForm.initialModuleIds = []
  }
}

const loadList = async () => {
  loading.value = true
  try {
    list.value = await EntityApi.listMerchants()
  } finally {
    loading.value = false
  }
}

const showCredentials = (
  name: string,
  loginUsername: string,
  loginPassword: string,
  modules: string[]
) => {
  credentialInfo.name = name
  credentialInfo.loginUsername = loginUsername
  credentialInfo.loginPassword = loginPassword
  credentialInfo.modules = modules
  credentialVisible.value = true
}

const copyCredentials = async () => {
  const text = [
    `主体：${credentialInfo.name}`,
    `登录账号：${credentialInfo.loginUsername}`,
    `登录密码：${credentialInfo.loginPassword}`,
    `已开模块：${credentialInfo.modules.map(moduleLabel).join('、') || '无（可稍后在列表开通）'}`,
    'B 端入口：商家工作台'
  ].join('\n')
  try {
    await navigator.clipboard.writeText(text)
    ElMessage.success('已复制到剪贴板')
  } catch {
    ElMessage.warning('复制失败，请手动复制')
  }
}

const onCreate = async () => {
  if (!createForm.name.trim() || !createForm.contactPhone.trim()) {
    ElMessage.warning('请填写主体名称和联系手机')
    return
  }
  if (!createForm.loginUsername.trim() || !createForm.loginPassword) {
    ElMessage.warning('请填写登录账号和密码')
    return
  }
  submitting.value = true
  const password = createForm.loginPassword
  const modules = [...createForm.initialModuleIds]
  const entityName = createForm.name.trim()
  const loginUsernameInput = createForm.loginUsername.trim()
  try {
    const r = await EntityApi.createMerchant({
      ...createForm,
      name: entityName,
      contactPhone: createForm.contactPhone.trim(),
      loginUsername: loginUsernameInput
    })
    createVisible.value = false
    resetCreateForm()
    await loadList()
    showCredentials(entityName, r.loginUsername, password, modules)
  } finally {
    submitting.value = false
  }
}

const openModuleDialog = async (row: EntityApi.MerchantEntityItem, moduleId?: string) => {
  openMerchantId.value = row.id
  appendModuleOptions.value = await EntityApi.getMerchantModuleOptions('ADMIN_APPEND', row.id)
  openModuleId.value =
    moduleId && appendModuleOptions.value.some((option) => option.moduleId === moduleId)
      ? moduleId
      : appendModuleOptions.value[0]?.moduleId || ''
  moduleForm.name = row.name
  moduleForm.city = '杭州'
  moduleForm.propertyType = 0
  moduleForm.operationMode = 'THIRD_PARTY'
  moduleForm.settleCycle = 'MONTHLY'
  moduleForm.commissionRate = 0
  moduleVisible.value = true
}

const onOpenModule = async () => {
  if (!openModuleId.value) {
    ElMessage.warning('当前商家暂无可开通模块')
    return
  }
  submitting.value = true
  try {
    const row = list.value.find((x) => x.id === openMerchantId.value)
    await EntityApi.openModule({
      merchantId: openMerchantId.value,
      moduleId: openModuleId.value,
      scene: 'ADMIN_APPEND',
      params: {
        name: moduleForm.name,
        city: moduleForm.city,
        contactPhone: row?.contactPhone,
        propertyType: moduleForm.propertyType,
        operationMode: moduleForm.operationMode,
        settleCycle: moduleForm.settleCycle,
        commissionRate: moduleForm.commissionRate
      }
    })
    ElMessage.success(`${moduleLabel(openModuleId.value)}模块已开通`)
    moduleVisible.value = false
    await loadList()
  } finally {
    submitting.value = false
  }
}

const onBackfill = async () => {
  const n = await EntityApi.backfillEntitlements()
  ElMessage.success(`已回填 ${n} 条模块开通记录`)
  await loadList()
}

const handleRouteQuery = async () => {
  const action = route.query.action as string | undefined
  const module = route.query.module as string | undefined
  const merchantId = route.query.merchantId ? Number(route.query.merchantId) : undefined

  if (action === 'create') {
    openCreateDialog(module)
  } else if (action === 'open' && module && merchantId) {
    const row = list.value.find((x) => x.id === merchantId)
    if (row) {
      await openModuleDialog(row, module)
    } else {
      ElMessage.warning('未找到指定商家主体')
    }
  }

  if (action || module || merchantId != null) {
    await router.replace({ path: EntityApi.MERCHANT_ENTITY_ADMIN_PATH })
  }
}

onMounted(async () => {
  await loadList()
  await handleRouteQuery()
})
</script>
